"use client";
import * as U from "react-dom";
import { u as k } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as Y } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as N } from "./FormContext-CYX6HnEQ.mjs";
import { u as _, D as w } from "./FieldRootContext-Cj7-dNhd.mjs";
import * as T from "react";
import { u as q } from "./useTimeout-BRUciAq6.mjs";
import { u as z } from "./useEventCallback-CjuAhyNz.mjs";
import { m as L } from "./useRenderElement-B8V3_e8R.mjs";
function I(t, l) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !l && t.state.valid
    }
  };
}
function $(t) {
  const {
    formRef: l
  } = N(), {
    invalid: o,
    markedDirtyRef: C,
    validityData: m,
    setValidityData: p
  } = _(), {
    enabled: v = !0,
    value: D,
    id: n,
    name: M,
    controlRef: b,
    commitValidation: y
  } = t, s = Y(t.getValue);
  k(() => {
    var V;
    if (!v)
      return;
    let i = D;
    i === void 0 && (i = (V = s.current) == null ? void 0 : V.call(s)), m.initialValue === null && i !== m.initialValue && p((d) => ({
      ...d,
      initialValue: i
    }));
  }, [v, p, D, m.initialValue, s]), k(() => {
    v && n && l.current.fields.set(n, {
      controlRef: b,
      validityData: I(m, o),
      validate() {
        var V;
        let i = D;
        i === void 0 && (i = (V = s.current) == null ? void 0 : V.call(s)), C.current = !0, U.flushSync(() => y(i));
      },
      getValueRef: s,
      name: M
    });
  }, [y, b, v, l, s, n, o, C, M, m, D]), k(() => {
    const i = l.current.fields;
    return () => {
      n && i.delete(n);
    };
  }, [l, n]);
}
const x = Object.keys(w);
function B(t) {
  if (!t || t.valid || !t.valueMissing)
    return !1;
  let l = !1;
  for (const o of x)
    o !== "valid" && (o === "valueMissing" && (l = t[o]), t[o] && (l = !1));
  return l;
}
function ee() {
  const {
    setValidityData: t,
    validate: l,
    messageIds: o,
    validityData: C,
    validationMode: m,
    validationDebounceTime: p,
    invalid: v,
    markedDirtyRef: D,
    controlId: n,
    state: M,
    name: b
  } = _(), {
    formRef: y,
    clearErrors: s
  } = N(), i = q(), V = T.useRef(null), d = z(async (g, R = !1) => {
    const r = V.current;
    if (!r)
      return;
    if (R) {
      if (M.valid !== !1)
        return;
      const c = r.validity;
      if (!c.valueMissing) {
        const f = {
          value: g,
          state: {
            ...w,
            valid: !0
          },
          error: "",
          errors: [],
          initialValue: C.initialValue
        };
        if (r.setCustomValidity(""), n) {
          const e = y.current.fields.get(n);
          e && y.current.fields.set(n, {
            ...e,
            ...I(f, !1)
            // invalid = false
          });
        }
        t(f);
        return;
      }
      const a = x.reduce((f, e) => (f[e] = c[e], f), {});
      if (!a.valid && !B(a))
        return;
    }
    function K(c) {
      const a = x.reduce((e, E) => (e[E] = c.validity[E], e), {});
      let f = !1;
      for (const e of x)
        if (e !== "valid") {
          if (e === "valueMissing" && a[e])
            f = !0;
          else if (a[e])
            return a;
        }
      return f && !D.current && (a.valid = !0, a.valueMissing = !1), a;
    }
    i.clear();
    let u = null, F = [];
    const h = K(r);
    let j;
    if (r.validationMessage)
      j = r.validationMessage, F = [r.validationMessage];
    else {
      const c = Array.from(y.current.fields.values()).reduce((f, e) => {
        var E, S;
        return e.name && e.getValueRef && (f[e.name] = (S = (E = e.getValueRef).current) == null ? void 0 : S.call(E)), f;
      }, {}), a = l(g, c);
      typeof a == "object" && a !== null && "then" in a ? u = await a : u = a, u !== null && (h.valid = !1, h.customError = !0, Array.isArray(u) ? (F = u, r.setCustomValidity(u.join(`
`))) : u && (F = [u], r.setCustomValidity(u)));
    }
    const P = {
      value: g,
      state: h,
      error: j ?? (Array.isArray(u) ? u[0] : u ?? ""),
      errors: F,
      initialValue: C.initialValue
    };
    if (n) {
      const c = y.current.fields.get(n);
      c && y.current.fields.set(n, {
        ...c,
        ...I(P, v)
      });
    }
    t(P);
  }), A = T.useCallback((g = {}) => L({
    ...o.length && {
      "aria-describedby": o.join(" ")
    },
    ...M.valid === !1 && {
      "aria-invalid": !0
    }
  }, g), [o, M.valid]), O = T.useCallback((g = {}) => L({
    onChange(R) {
      if (R.nativeEvent.defaultPrevented)
        return;
      if (s(b), m !== "onChange") {
        d(R.currentTarget.value, !0);
        return;
      }
      if (v)
        return;
      const r = R.currentTarget;
      if (r.value === "") {
        d(r.value);
        return;
      }
      i.clear(), p ? i.start(p, () => {
        d(r.value);
      }) : d(r.value);
    }
  }, A(g)), [A, s, b, i, d, v, m, p]);
  return T.useMemo(() => ({
    getValidationProps: A,
    getInputValidationProps: O,
    inputRef: V,
    commitValidation: d
  }), [A, O, d]);
}
export {
  $ as a,
  ee as u
};
